import { render, staticRenderFns } from "./CeremonyEventList.vue?vue&type=template&id=7535986e&scoped=true"
import script from "./CeremonyEventList.vue?vue&type=script&lang=js"
export * from "./CeremonyEventList.vue?vue&type=script&lang=js"
import style0 from "./CeremonyEventList.vue?vue&type=style&index=0&id=7535986e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7535986e",
  null
  
)

export default component.exports